import React from 'react';
import {PageContainer, PageContent} from '../../components/Page';
import Helmet from 'react-helmet';
import {withRouteData} from "react-static";

export default withRouteData(({ content }) => <React.Fragment>
  <Helmet title={content ? content.title : 'Disclaimer'} />
  <PageContainer>
    <PageContent html={content ? content.body : ''} />
  </PageContainer>
</React.Fragment>);